import type { SlashCommandItem } from './types';

export interface SlashCategory {
  name: string;
  nameHe: string;
  items: SlashCommandItem[];
}

export function matchesQuery(item: SlashCommandItem, query: string): boolean {
  const q = (query ?? '').trim().toLowerCase();
  if (!q) return true;
  const haystack = [item.title, item.titleHe, item.description, ...item.aliases];
  return haystack.some((s) => (s ?? '').toLowerCase().includes(q));
}

/**
 * Generic in the category type on purpose: a caller passing
 * `SlashCommandCategory[]` (which carries the A–K `family` slug on top of
 * this shape) gets the same type back, instead of having the slug widened
 * away to plain `SlashCategory` on the way out. A filter should narrow the
 * items, never the type.
 */
export function filterSlashCategories<T extends SlashCategory>(
  query: string,
  categories: T[]
): T[] {
  return categories
    .map((cat) => ({ ...cat, items: cat.items.filter((it) => matchesQuery(it, query)) }))
    .filter((cat) => cat.items.length > 0);
}

export function filterSlashItems(
  query: string,
  items: SlashCommandItem[]
): SlashCommandItem[] {
  return items.filter((it) => matchesQuery(it, query));
}
